import React from "react";

import { Box, Typography, TypographyProps } from "@mui/material";

export const Para14Text: React.FC<
  TypographyProps<React.ElementType, { component?: React.ElementType }> & {
    fontWeight?: number;
  }
> = ({ fontWeight = 400, ...otherProps }) => (
  <Typography component="div">
    <Box
      fontSize={14}
      lineHeight={"20.41px"}
      fontWeight={fontWeight}
      letterSpacing={0.1}
    >
      <Typography variant="inherit" component="p" {...otherProps} />
    </Box>
  </Typography>
);
